// Trade-specific pricing fields — what shows in the Pricing section depends
// on which trades the contractor selected on the Trades & Services step.
// Each pricing field is keyed by `<tradeSlug>__<fieldKey>` in submitted data.

export const TRADES = [
  "Carpentry/Framing",
  "Drywall",
  "Flooring",
  "Painting",
  "HVAC",
  "Plumbing",
  "Electrical",
  "Concrete",
  "Excavation/Site Work",
  "Roofing",
  "Other",
];

export const SERVICE_AREAS = ["Austin", "DFW", "Houston", "San Antonio", "Waco", "Other"];

export const PROJECT_TYPES = [
  "Residential Remodels",
  "Commercial TI",
  "Ground-Up Construction",
  "Other",
];

export const AVAILABILITY_OPTIONS = [
  "Available Now",
  "Available Within 2 Weeks",
  "Available Within 1 Month",
  "Available After 1 Month",
  "Seasonal",
  "Project-Based",
  "Not Currently Available",
];

export const START_TIMEFRAMES = [
  "Immediately",
  "Within 1 Week",
  "Within 2 Weeks",
  "Within 30 Days",
  "Within 60 Days",
  "Within 90 Days",
  "Other",
];

export const PRICING_BASIS = ["Labor only", "Labor + materials", "Both, depending on scope"];

export const PAYMENT_METHODS = ["ACH transfer", "Check", "Wire transfer", "PayPal", "Zelle", "Other"];

export const US_STATES = [
  "AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD",
  "MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC",
  "SD","TN","TX","UT","VT","VA","WA","WV","WI","WY","DC",
];

// Pricing fields per trade. Empty array = no pricing fields (free-form notes only).
// Each field: { key, label, hint, prefix (optional, e.g. "$") }
export const TRADE_PRICING_FIELDS = {
  "Carpentry/Framing": [
    { key: "per_linear_ft", label: "Price per linear ft", prefix: "$", hint: "Framing / trim per LF" },
    { key: "per_sq_ft", label: "Price per sq ft", prefix: "$", hint: "Framing / sheathing per SF" },
    { key: "hourly_rate", label: "Hourly labor rate", prefix: "$", hint: "Trim / finish carpentry" },
  ],
  "Drywall": [
    { key: "hang_per_sq_ft", label: "Hang per sq ft", prefix: "$" },
    { key: "finish_per_sq_ft", label: "Finish per sq ft", prefix: "$", hint: "Texture / paint-ready" },
    { key: "per_board", label: "Per 4x8 board (hang + finish)", prefix: "$" },
    { key: "patch_min", label: "Patch minimum charge", prefix: "$" },
  ],
  "Flooring": [
    { key: "lvp_per_sq_ft", label: "LVP / laminate per sq ft", prefix: "$" },
    { key: "tile_per_sq_ft", label: "Tile install per sq ft", prefix: "$" },
    { key: "hardwood_per_sq_ft", label: "Hardwood install per sq ft", prefix: "$" },
    { key: "demo_per_sq_ft", label: "Demo / removal per sq ft", prefix: "$" },
  ],
  "Painting": [
    { key: "interior_per_sq_ft", label: "Interior per sq ft", prefix: "$", hint: "Walls + ceilings" },
    { key: "exterior_per_sq_ft", label: "Exterior per sq ft", prefix: "$" },
    { key: "per_room", label: "Per standard room", prefix: "$", hint: "12x12, walls only" },
    { key: "hourly_rate", label: "Hourly rate", prefix: "$" },
  ],
  "HVAC": [
    { key: "per_ton_install", label: "Install per ton", prefix: "$" },
    { key: "service_call", label: "Service call flat fee", prefix: "$" },
    { key: "hourly_rate", label: "Hourly rate after diagnosis", prefix: "$" },
    { key: "ductwork_per_run", label: "Ductwork per run", prefix: "$" },
  ],
  "Plumbing": [
    { key: "per_fixture", label: "Rough-in per fixture", prefix: "$" },
    { key: "service_call", label: "Service call flat fee", prefix: "$" },
    { key: "hourly_rate", label: "Hourly rate", prefix: "$" },
    { key: "water_heater_swap", label: "Water heater swap", prefix: "$" },
  ],
  "Electrical": [
    { key: "per_outlet", label: "Per outlet / switch", prefix: "$" },
    { key: "per_panel", label: "Panel upgrade", prefix: "$" },
    { key: "service_call", label: "Service call flat fee", prefix: "$" },
    { key: "hourly_rate", label: "Hourly rate", prefix: "$" },
  ],
  "Concrete": [
    { key: "slab_per_sq_ft", label: "Slab per sq ft", prefix: "$" },
    { key: "decorative_per_sq_ft", label: "Decorative / stamped per sq ft", prefix: "$" },
    { key: "per_yard", label: "Per cubic yard", prefix: "$" },
    { key: "mobilization", label: "Mobilization fee", prefix: "$" },
  ],
  "Excavation/Site Work": [
    { key: "per_hour_equipment", label: "Per hour (with equipment)", prefix: "$" },
    { key: "per_yard_haul", label: "Per yard hauled", prefix: "$" },
    { key: "mobilization", label: "Mobilization fee", prefix: "$" },
    { key: "trenching_per_lf", label: "Trenching per LF", prefix: "$" },
  ],
  "Roofing": [
    { key: "per_square", label: "Per square (100 sq ft)", prefix: "$", hint: "Tear-off + install" },
    { key: "flashing_per_lf", label: "Flashing per LF", prefix: "$" },
    { key: "tear_off_fee", label: "Tear-off per square", prefix: "$" },
    { key: "repair_min", label: "Repair minimum", prefix: "$" },
  ],
  "Other": [],
};
